import { Input, Pagination, Table } from "@/components";
import { HiOutlineSearch } from "react-icons/hi";
import { useMonthlyInspectionList } from "./hooks";
import { MonthlyInspectionDetail } from "./components";

const MonthlyInspectionList = () => {
  const {
    inputValue,
    setInputValue,
    handleUsersKeyDown,
    updateSearchParams,
    KEYS_SEARCH_PARAMS,
    monthlyInspectionListColumns,
    currentPage,
    monthlyChecks,
    isLoading,
    id,
  } = useMonthlyInspectionList();

  const hasPagination = Array.isArray(monthlyChecks.data) && monthlyChecks.data.length > 0;

  return (
    <div>
      <div className="py-4 space-y-1">
        <p className="text-lg font-bold leading-7">随時点検管理</p>
        <p className="text-light_secondary font-normal text-xs leading-4.5">
          「店舗の表示が適正か」随時、点検ください。下記画面で提出・回答状況を確認できます。未回答のものは点検の上、回答をお願いします。
        </p>
      </div>
      <div className="flex justify-between items-center gap-2">
        <Input
          placeholder="テキストを入力してください。"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className="max-w-[320px] !h-10 placeholder:text-grey-600 pr-4 !pl-[38px] text-sm"
          containerClassName="flex-1"
          classNameIcon="left-4"
          icon={
            <HiOutlineSearch className="w-[14.575px] h-[14.575px] text-action_light_active" />
          }
          onKeyDown={handleUsersKeyDown}
        />
      </div>
      <div className="pt-4">
        <div className="min-h-[calc(100vh-478px)]">
          <Table
            columns={monthlyInspectionListColumns}
            dataSource={monthlyChecks.data || []}
            loading={isLoading}
            bordered
            loadingClassname="h-[calc(100vh-530px)]"
          />
        </div>

        {hasPagination && (
          <Pagination
            currentPage={currentPage}
            totalPages={monthlyChecks.pagination?.pageCount || 0}
            onPageChange={(page: number) => {
              updateSearchParams({
                [KEYS_SEARCH_PARAMS.PAGE]: page.toString(),
              });
            }}
          />
        )}
      </div>

      {!!id && <MonthlyInspectionDetail />}
    </div>
  );
};

export { MonthlyInspectionList };
